import { useLocation } from 'react-router-dom';
import { OriginatorTopBar } from '../components/layout/originator/OriginatorTopBar';
import { OriginatorIconRail } from '../components/layout/originator/OriginatorIconRail';
import { titleForPath } from '../routes/pathTitles';
import { WorkspaceGate } from './WorkspaceGate';

function cleanTitle(title) {
  return title.replace(/^Originator(?:\s+workspace)?\s*[—-]\s*/i, '');
}

export function OriginatorShell() {
  const { pathname } = useLocation();
  const { title, subtitle } = titleForPath(pathname);

  return (
    <div className="relative flex h-dvh min-h-0 flex-col overflow-hidden bg-eorig-surface pt-3 font-sans text-sm text-eorig-ink">
      <OriginatorTopBar />
      <div className="flex min-h-0 flex-1 overflow-hidden">
        <OriginatorIconRail />
        <main className="relative min-h-0 min-w-0 flex-1 overflow-y-auto overflow-x-hidden px-4 py-5 sm:px-6 sm:py-6">
          <div className="mx-auto w-full max-w-7xl">
            <WorkspaceGate title={cleanTitle(title)} subtitle={subtitle} />
          </div>
        </main>
      </div>
    </div>
  );
}
